// Copyright (c) StrangeBee 2024

import { useLocalMessage } from '@Helpers/';
import { Divider, Space } from 'antd';
import React, { ReactElement } from 'react';
import { ICONS } from '@Constants/iconsApp';

export const DividerCustomize = (): ReactElement => {
    const i = useLocalMessage();
    return (
        <Divider>
            <Space>
                <ICONS.SettingIcon className="color-primary" />
                <span className="title-3b color-primary">{i('general.customize')}</span>
            </Space>
        </Divider>
    );
};
